import { SettingGroup } from "../types"
import { SettingStore } from "~models/setting-store"
import { WalletStore } from "~models/wallet-store"

type SecuritySchemaDeps = {
  settingStore: SettingStore
  walletStore: WalletStore
}
export const securitySchema = ({
  settingStore,
  walletStore,
}: SecuritySchemaDeps): SettingGroup[] => [
    {
        title: "密码设置",
        contents: [
            {
                id: "security.password",
                type: "navigate",
                title: "登录密码",
                content: "修改登录密码",
                suffix: {
                    type: "text",
                    value: "修改",
                },
                icon: "mm1",
                iconColor: "#ff6565",
                iconSize: 16,
                bg: "rgba(255, 101, 101, 0.1)"
            },
            {
                id: "security.verification",
                type: "navigate",
                title: "支付密码",
                content: "启用双重身份验证",
                suffix: {
                    type: "text",
                    value: walletStore.wp_confirmed === true ? "修改" : "未设置",
                },
                icon: "zfmm",
                iconColor: "#19986f",
                iconSize: 16,
                bg: "rgba(25, 152, 111, 0.1)"
            }
        ]
    },
    {
        title: "账户设置",
        contents: [
            {
                id: "security.account",
                type: "navigate",
                title: "手机号验证",
                content: "绑定手机号码用于安全验证",
                suffix: {
                    type: "text",
                    value: Boolean(walletStore.phone) ? "已绑定" : "未绑定",
                },
                icon: "sj2",
                iconColor: "#ec8027",
                iconSize: 16,
                bg: "rgba(236, 128, 39, 0.1)"
            },
            {
                id: "security.email",
                type: "navigate",
                title: "邮箱验证",
                content: "绑定邮箱用于安全验证",
                suffix: {
                    type: "text",
                    value: Boolean(walletStore.email) ? "已绑定" : "未绑定",
                },
                icon: "yx1",
                iconColor: "#4e98f3",
                iconSize: 16,
                bg: "rgba(78, 152, 243, 0.1)"
            },
            {
                id: "security.security",
                type: "navigate",
                title: "谷歌验证",
                content: "使用谷歌验证器进行双重功能验证",
                suffix: {
                    type: "text",
                    value: walletStore.is_2fa_enabled === true ? "已启用" : "未启用",
                },
                icon: "gg",
                iconColor: "#ff6565",
                iconSize: 16,
                bg: "rgba(255, 101, 101, 0.1)"
            }
        ]
    },
    {
        title: "安全选项",
        contents: [
            {
                id: "security.login",
                type: "switch",
                title: "登录通知",
                content: "修改登录密码",
                suffix: {
                    type: "switch",
                    value: settingStore.loginNotify,
                    onChange: settingStore.setLoginNotify,
                },
                icon: "dltz",
                iconColor: "#ff6565",
                iconSize: 16,
                bg: "rgba(255, 101, 101, 0.1)"
            },
            {
                id: "security.deviceVerification",
                type: "switch",
                title: "设备验证",
                content: "新设备登录需要验证",
                suffix: {
                    type: "switch",
                    value: walletStore.device_verify_enabled,
                    onChange: settingStore.setDeviceVerify,
                },
                icon: "sbyz",
                iconColor: "#c922c4",
                iconSize: 16,
                bg: "rgba(201, 34, 196, 0.1)"
            },
            {
                id: "security.authentication",
                type: "switch",
                title: "双重验证",
                content: "启用双重身份验证",
                suffix: {
                    type: "switch",
                    // disabled: true,
                    value: walletStore.is_2fa_enabled,
                    onChange: settingStore.setDoubleVerify,
                },
                icon: "scrz",
                iconColor: "#07c160",
                iconSize: 16,
                bg: "rgba(25, 152, 111, 0.1)"
            }
        ]
    }
]
